import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import Section from "../../../common/section";
import TooltipButton from "../../../common/tooltipButton";
import UserService from "../../../../services/UserService";
import { errorText } from "../../../../helpers/ErrorMessage";

// Resend welcome email (F1), for a user who has not signed in yet: the same
// welcome they got when they were added (a fresh set-password link for a
// Local user, the sign-in link for an SSO user). A refusal says why (the
// welcome email switched off, or too many resends this hour).
const UserWelcomeEmailCard = ({ record, canUpdate }) => {
  const intl = useIntl();
  const [sending, setSending] = useState(false);
  const name = `${record?.firstName || ""} ${record?.lastName || ""}`.trim();

  const resend = async () => {
    setSending(true);
    try {
      await UserService.resendWelcomeEmail({ id: record.id });
      toast.success(
        intl.formatMessage(
          { id: "resend_welcome_email_done" },
          { email: record.email }
        )
      );
    } catch (error) {
      toast.error(
        errorText(error?.response?.data, intl, "something_else_wrong")
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="edexlms-details-card completed" style={{ flex: 1 }}>
      <Section
        title={intl.formatMessage({ id: "welcome_email" })}
        i18n={false}
        headerAction={
          <TooltipButton
            type="button"
            outlined
            size="small"
            icon="pi pi-send"
            label={intl.formatMessage({ id: "resend_welcome_email" })}
            onClick={resend}
            disabled={!canUpdate || sending}
            loading={sending}
            tooltipOptions={{ position: "bottom" }}
            tooltip={canUpdate ? "" : intl.formatMessage({ id: "no_permission" })}
          />
        }
      >
        <div>
          {intl.formatMessage({ id: "welcome_email_not_signed_in" }, { name })}
        </div>
      </Section>
    </div>
  );
};

export default UserWelcomeEmailCard;
